define(['text!./templates/qnb-info-bar.html'],
    (templateStr)=> {
        return ['$filter', ($filter)=> {
            return {
                restrict: 'A',
                template: templateStr,
                scope: {
                    'submission': '=gwQnbInfoBar'
                },
                controller: ['$scope', (scope)=> {
                    scope.$filter = $filter;
                    scope.getAddress = ()=> {
                        if (!scope.submission || !scope.submission.draftData || !scope.submission.draftData.accountHolder || !scope.submission.draftData.policyAddress) {
                            return [];
                        }

                        const addr = scope.submission.draftData.policyAddress;
                        return [addr.addressLine1,
                            `${addr.city}, ${addr.state} ${addr.postalCode}`];
                    };
                }]
            };
        }];
    });



// WEBPACK FOOTER //
// ../common/js/src/integration/quoteandbind/directives/QnbInfoBar.js